import { render, staticRenderFns } from "./MessageAccueil.vue?vue&type=template&id=13bc5288&"
import script from "./MessageAccueil.vue?vue&type=script&lang=js&"
export * from "./MessageAccueil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports